import React, { memo } from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

const useStyles = makeStyles(() => ({
  postCard: {
    backgroundColor: "transparent",
    border: "none",
    boxShadow: "none",
    marginBottom: "30px",
    cursor: "pointer",
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "translateY(-5px)"
    }
  },
  postImage: {
    width: "100%",
    height: "200px",
    objectFit: "cover",
    borderRadius: "8px",
    marginBottom: "15px"
  },
  placeholderImage: {
    width: "100%",
    height: "200px",
    backgroundColor: "#f5f5f5",
    borderRadius: "8px",
    marginBottom: "15px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#999",
    fontSize: "0.9rem"
  },
  postMeta: {
    fontSize: "0.875rem",
    color: "#999",
    marginBottom: "10px"
  },
  postTitle: {
    fontSize: "1.25rem",
    fontWeight: "500",
    marginBottom: "15px",
    color: "#3C4858",
    textDecoration: "none",
    lineHeight: "1.4",
    "&:hover": {
      color: "#f7931e",
      textDecoration: "none"
    }
  },
  postExcerpt: {
    fontSize: "0.95rem",
    lineHeight: "1.6",
    color: "#666",
    marginBottom: "0",
    display: "-webkit-box",
    "-webkit-line-clamp": 3,
    "-webkit-box-orient": "vertical",
    overflow: "hidden"
  }
}));

const PostGrid = memo(({ posts, formatDate }) => {
  const classes = useStyles();

  const renderPostCard = (post) => (
    <div key={post.id} className={classes.postCard}>
      <Link to={`/blog/post/${post.slug}`} style={{ textDecoration: 'none' }}>
        {post.featured_image ? (
          <img 
            src={post.featured_image} 
            alt={post.title}
            className={classes.postImage}
          />
        ) : (
          <div className={classes.placeholderImage}>
            No Image Available
          </div>
        )}
        
        <div className={classes.postMeta}>
          {formatDate(post.created_at)}
        </div>
        
        <h3 className={classes.postTitle}>
          {post.title}
        </h3>
        
        <div 
          className={classes.postExcerpt}
          dangerouslySetInnerHTML={{ __html: post.excerpt }}
        />
      </Link>
    </div>
  );

  return (
    <GridContainer>
      {posts.map((post) => (
        <GridItem xs={12} sm={6} md={4} key={post.id}>
          {renderPostCard(post)}
        </GridItem>
      ))}
    </GridContainer>
  );
});

PostGrid.displayName = 'PostGrid';

export default PostGrid;